/*
 * navbar
 */
import { Link } from "@tanstack/react-router"
import { cn } from "@emr/react-ui"
import type { ReactNode } from "react"

export type NavbarProps = {
	title?: ReactNode
	titleHref?: string
	Sidebar?: ReactNode
	RightSide?: ReactNode
	titleClassName?: string
	className?: string
}

export function Navbar({
	title,
	titleHref,
	Sidebar,
	RightSide,
	titleClassName,
	className,
}: NavbarProps) {
	const TitleContainer = titleHref ? Link : "div"

	return (
		<nav
			className={cn([
				"bg-primary text-primary-foreground h-(--navbar-height) z-10 flex flex-row items-center justify-between px-6 py-2 lg:px-8",
				className,
			])}
		>
			<div className={"inline-flex flex-row items-center gap-2"}>
				{Sidebar}
				<TitleContainer className={titleClassName} to={titleHref as any}>
					<h2 className={"m-0 text-xl font-semibold"}>{title}</h2>
				</TitleContainer>
			</div>
			<div className={"inline-flex flex-row items-center gap-4"}>
				{RightSide}
			</div>
		</nav>
	)
}
